<template>
  <div>
    <div v-if="template == 'default'">
      <div v-if="step == 'form'" class="form">

        <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.name }">
          <label class="form-label form__label">Ваше имя</label>
          <input type="text" class="form-control form-control--white" v-model="contact.name">
          <p class="invalid-feedback" v-if="errors.name">
            {{ errors.name.join(', ') }}
          </p>
        </div>
        
        <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.phone }">
          <label class="form-label form__label">Телефон</label>
          <input type="text" class="form-control form-control--white" v-model="contact.phone" v-mask="'+7(###)###-##-##'" placeholder="+7(xxx)xxx-xx-xx">
          <p class="invalid-feedback" v-if="errors.phone">
            {{ errors.phone.join(', ') }}</p>
        </div>

        <div class="form-group form__group" v-if="!messageInput">
          <a href="javascript:;" class="dashed-link" @click="messageInput = !messageInput">Ввести сообщение или вопрос</a>
        </div>

        <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.message }" v-if="messageInput">
          <label class="form-label form__label">Вопрос или сообщение</label>
          <textarea
            rows="3"
            class="form-control form-control--white form-message"
            v-model="contact.message"></textarea>
          <p class="invalid-feedback" v-if="errors.message">
            {{ errors.message.join(', ') }}
          </p>
        </div>

        <div class="form__actions">
          <button type="button" class="btn btn-primary accept-btn modal__accept-btn w-100" v-on:click="sendForm">Отправить</button>
          <p class="form-accept__text text-center mt-2">Отправляя вы принимаете <a href="/legal/">условия</a> обработки персональных данных</p>
        </div>
      </div>

      <div v-if="step == 'complete'">
        <p class="text-success">
          Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
        </p>
      </div>    
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'

import FormMixin from '../vue_mixins/FormMixin.vue'

Vue.use(VueMask)


export default {
  name: 'ContactForm',
  props: {
    theme: {
      type: String,
      default: 'Сообщение с формы'
    },
    template: {
      type: String,
      default: 'default'
    },
    initialMessage: {
      type: String,
      default: null
    }
  },
  mixins: [FormMixin],
  components: {
  },
  data() {
    return {
      contact: {
        id: null,
        phone: null,
        message: null
      },
      errors: {},
      step: 'form',
      theme_message: this.theme,
      messageInput: false
    }
  },
  mounted () {
  },
  methods: {
    sendForm: function () {
      axios.put("/contacts/api/consult/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.contact.theme_message = this.theme_message;
        this.step = 'complete';
        ym(this.ymCounterId,'reachGoal','CONTACT_MESSAGE')
      })
      .catch(error => {
        this.errors = error.response.data;
        setTimeout(() => {
          this.initData()
        }, 5000)
      });
    },

    initData () {
      this.contact = {
        id: null,
        phone: null,
        message: null
      }
      this.errors = {}
      this.step = 'form'
    }
  }
}
</script>

<style lang="scss">
</style>
